import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { FC } from 'react';
import { ControlledSelectInput } from 'Components/ControlledSelectInput';
import { IFormMetaData } from 'API';
import { Avatar, Link, Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { Download2 } from 'Images';

export interface ISelectRequestType {
  value: string;
  onChange: (value: string) => void;
  uploadFilesList?: IFormMetaData;
  errorMsg?: string;
}
export const SelectRequestType: FC<ISelectRequestType> = ({
  value,
  onChange,
  uploadFilesList,
  errorMsg,
}) => {
  const dictionary = Dictionary[DICTIONARY.UniversalRequest].uploadFile;
  const isDesktop = useIsDesktop();

  const getValue = () =>
    uploadFilesList?.attachments && uploadFilesList.attachments.length === 1
      ? uploadFilesList?.attachments[0].id
      : value;

  const getItem = () =>
    uploadFilesList?.attachments?.find((item) => getValue() === item?.id);

  return (
    <>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='center'
        spacing={2}
        mb={isDesktop ? 3 : 0}
      >
        <ControlledSelectInput
          label={dictionary.fileType}
          options={
            uploadFilesList?.attachments
              ? uploadFilesList?.attachments.map((item) => item?.name)
              : []
          }
          optionsValues={
            uploadFilesList?.attachments
              ? uploadFilesList?.attachments.map((item) => item?.id)
              : []
          }
          value={getValue()}
          defaultValue={
            uploadFilesList?.attachments &&
            uploadFilesList.attachments.length === 1
              ? uploadFilesList.attachments[0].id // Set the default value for single option
              : undefined // No default value if there are multiple options
          }
          setValue={onChange}
          sx={{
            width: '100% !important',

            '& .MuiOutlinedInput-root': {
              backgroundColor: isDesktop ? undefined : '#fff',
              borderRadius: isDesktop ? undefined : '8px',
            },
          }}
          errorMsg={errorMsg}
          inputProps={{
            ['aria-invalid']: errorMsg ? true : false,
            ['aria-required']: true,
          }}
        />
      </Stack>
      {getItem()?.downloadFormUrl && (
        <Stack mt={isDesktop ? undefined : '18px'} mb='12px' gap='6px'>
          <Typography variant='body3'>
            {dictionary.doNotHaveFile(getItem()!.name)}
          </Typography>
          <Link
            sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}
            href={getItem()!.downloadFormUrl}
            target='_blank'
          >
            <Typography variant='body3'>{dictionary.downloadFile}</Typography>
            <Avatar
              sx={{ width: '20px', height: '20px' }}
              alt=''
              src={Download2}
            />
          </Link>
        </Stack>
      )}
    </>
  );
};
